const focusElementByRef = (
    ref: React.RefObject<HTMLElement | null>
): NodeJS.Timeout | undefined => {
    if (!ref.current) return undefined;

    const hasFocus =
        document.activeElement === ref.current ||
        document.querySelector(":focus") === ref.current;
    if (hasFocus) return undefined;

    const fakeInput = document.createElement("input");
    fakeInput.setAttribute("type", "text");
    fakeInput.style.position = "absolute";
    fakeInput.style.opacity = "0.1001";
    fakeInput.style.height = "0";
    fakeInput.style.fontSize = "16px";
    fakeInput.readOnly = true;

    document.body.prepend(fakeInput);

    fakeInput.focus();
    const timeout = setTimeout(() => {
        ref?.current?.focus();
        const value = fakeInput.getAttribute("value");
        if (value) {
            ref?.current?.setAttribute("value", value);
        }
        fakeInput.remove();
    }, 50);

    return timeout;
};

export default focusElementByRef;
